import React from 'react';
import AboutImage from './AboutImage';
import { INTRO_FEATURES_FALLBACK } from '../../utils/aboutLayoutDefaults';
import './about.css';

const AboutIntroSection = ({ data }) => {
    if (!data) return null;

    const paragraphs = data.introParagraphs || [];
    const features = data.introFeatures?.length ? data.introFeatures : INTRO_FEATURES_FALLBACK;

    return (
        <section className="w-full bg-white py-10 lg:py-14">
            <div className="about-shell">
                <div className="about-intro-grid">
                    <div className="flex flex-col min-w-0 justify-between">
                        <div>
                            <h2 className="text-lg md:text-xl font-extrabold text-slate-900 uppercase tracking-tight mb-0.5">
                                {data.introSectionTitle || 'VỀ CHÚNG TÔI'}
                            </h2>

                            <h3 className="text-2xl md:text-3xl font-black text-[#E31E24] uppercase tracking-tight mb-4">
                                {data.introBrandTitle || 'TRUNG ANH GARAGE'}
                            </h3>

                            <div className="space-y-3 text-slate-700 text-sm md:text-[14.5px] leading-relaxed text-justify mb-6">
                                {paragraphs.map((para, i) => (
                                    <p key={i}>{para}</p>
                                ))}
                            </div>
                        </div>

                        <div className="about-intro-features">
                            {features.map((item, i) => (
                                <div key={`feature-${i}-${item.title}`} className="about-intro-feature-item">
                                    <div className="about-icon-circle">
                                        <AboutImage
                                            src={item.iconUrl}
                                            fallback={`/assets/images/icon-dv-${(i % 3) + 1}.png`}
                                            alt={item.title}
                                            variant="icon"
                                            className="about-icon-white"
                                        />
                                    </div>
                                    {item.title && (
                                        <h4 className="text-[11px] md:text-xs font-black text-slate-900 uppercase mb-1 leading-tight text-center">
                                            {item.title}
                                        </h4>
                                    )}
                                    {item.description && (
                                        <p className="text-[10px] md:text-[11px] text-slate-500 leading-tight text-center">
                                            {item.description}
                                        </p>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="about-media-box about-media-box--hero min-w-0">
                        <AboutImage
                            src={data.introHeroImage}
                            fallback="/assets/introduce.png"
                            alt={data.introBrandTitle}
                            variant="cover"
                        />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AboutIntroSection;
